import $ from "jquery";
import kari from "#templates/pages/dialog.js";
import { isMobile } from "#scripts/general_functions.js";
import { getApiWarnings } from "#scripts/warnings";
import language from "#scripts/translation";
import { languageSelector } from "#scripts/langselector";
import { userLogin } from "#scripts/userlogin";
// import "#components/index.js";
//<header-button type="search">${language("NAV_SEARCH")}</header-button>;

export default function () {
	const res = window.serverdata.configMeta.aim;
	const headerStyle = !res.headerFluid ? "container" : "container-fluid"; // Changed default header style to container-fluid
	// let logo = res.logo.filter((elem) => elem.type === "allover")[0];
	let logo = res.logo.filter((elem) => elem.type === "allover")[0] || res.logo[0];

	const logoMobile = res.logo.filter((elem) => elem.type === "mobile")[0];
	const logoFrontpage = res.logo.filter((elem) => elem.type === "frontpage")[0];
	const logoFrontpageMenu = res.logo.filter((elem) => elem.type === "frontpage-menu")[0];

	if (window.serverdata.configMeta.aim.template === "frontpage" && logoFrontpage) {
		logo = logoFrontpage;
	}
	if (isMobile() && logoMobile) {
		logo = logoMobile;
	}

	const logoTestDesign = res.logo.filter((elem) => elem.type === `devstyle_${window.AimCookies.DevStyles}`)[0];
	if (logoTestDesign) {
		logo = logoTestDesign;
	}

	const style = logo?.inlineStyles && logo?.inlineStyles.length > 0 ? `style='${logo?.inlineStyles}'` : "";
	const cssclass = logo.cssclass && logo.cssclass.length > 0 ? logo.cssclass : "";
	const height = logo.height !== undefined ? `height='${logo.height}'` : "";
	const width = logo.height !== undefined ? `width='${logo?.width}'` : "";
	const searchEnabled = (window.serverdata.configMeta.aim?.searchEnabled ?? true) && !window.serverdata.configMeta.aim?.doNotUseSearch;
	getApiWarnings();

	const headerHtml = `
        <nav class="navbar navbar-default navbar-fixed-top header__nav header header__shadow">
          <div class="${headerStyle} p-lg-0">
             <div class="xrow">
                <div class="xcol-lg-12">
                    <div class="header--container">
										    <div class="skip-link">
                            <ul>
                                <li>
                                    <a class="skip" href="#maincontent">${language("HEADER_JUMPMAIN")}</a>
                                </li>
                                <li>
                                    <a class="skip" href="#menu-button">${language("HEADER_JUMPNAV")}</a>
                                </li>
                                <!--li>
                                    <a class="skip" href="/">${language("HEADER_JUMPSTART")}</a>
                                </li-->
                            </ul>
                        </div>

                        <a href="/" @click="reload" data-testid="logo">
                            <div class="header__shield-container">
                                <img class="header__shield ${cssclass}" alt="${logo?.alttext} - ${language("NAV_FRONTPAGE")}" src="${logo.filepath}" ${style} ${height} ${width} />
                            </div>
                        </a>
                        
                        <div class="header__icon-container">
                            ${languageSelector() || ""}
                            ${customLinks(res.headerLinks, true)}
														${userLogin() || ""}
                            ${searchEnabled ? `
																<button class="header__button__search" type="button" aria-label="åpne søk">
																	<div>
																		<span class="material-icons-outlined notranslate header__icon"></span>
																		<span class="header__button__text">${language("NAV_SEARCH")}
																			</span>
																	</div>
																</button>` : ""
		}
                            <button id="menu-button" class="header__button__navigation" type="button" aria-label="meny">
                              <div>
                                <span class="material-icons-outlined notranslate header__icon"></span>
                                <span class="header__button__text">${language("NAV_MENU")}</span>
                              </div>
                            </button>
                        </div> 
                    </div>
                </div>
             </div>
            </div>
            
            <div class="row">
              <div class="col p-0">
                  <div class="header--searchcontainer">
                      <div class="header__search"  role="search">
                          <div class="header__search__container">
                              <input type="search" name="searchsite" value="" class="input-control header__search__input" aria-label="søk">
                              <button class="header__button__dosearch" aria-label="søk">
                                  <span class="material-icons-outlined notranslate header__icon">&#xE8B6;</span>
                              </button>
                          </div>
                      </div>
                      <div class="header__search__closebutton"><span class="material-icons-outlined notranslate header__search__closebutton__icon">close</span></div>
                  </div>
              </div>
            </div>
        </nav>
        
        <div class="fullnav" id="menu_container">
            <div class="container p-0">
                <div class="row">
                    <div class="col-12">
                        <div class="fullnav__breadcrumb__container">
                            <div class="row fullnav__main">&nbsp;</div>
                        </div>
                        <div class="fullnav__extra"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="chatbot__container " id="chatbot__container"></div>
        <div class="warnings" id="warnings_container">&nbsp;</div>
        `;

	document.getElementById("header").innerHTML = headerHtml;

	$("html").on("click", ".fullnav__breadcrumb__link", function () {
		$(this).parent().nextAll().remove();
	});

	$("html").on("click", ".header__button__navigation", function (e) {
		$("body,html").scrollTop(0);
		$(this).toggleClass("is-active");
		const isExpanded = $(this).attr('aria-expanded') === 'true';
		$(this).attr('aria-expanded', !isExpanded);
		$(".header").toggleClass("is-active");

		const menu = document.getElementById('menu_container');
		const originalDisplay = menu.style.display;
		const frontpageShield = document.querySelector('.frontpage_template .header__shield');
		const menuVisible = menu && window.getComputedStyle(menu).display === 'block';

		// Choose the appropriate logo filepath
		let chosenLogo = null;
		if (logoFrontpageMenu?.filepath && !menuVisible) {
			chosenLogo = logoFrontpageMenu.filepath;
		} else if (logoFrontpage?.filepath && menuVisible) {
			chosenLogo = logoFrontpage.filepath;
		}

		// Apply the logo if everything’s in place
		if (chosenLogo && frontpageShield) {
			frontpageShield.src = chosenLogo;
		}

		menu.style.display = "block";
		// const width = menu.offsetWidth;
		menu.style.display = originalDisplay;

		// const mainHasVerticalScrollbar = document.documentElement.scrollHeight > window.innerHeight;
		// const menuHasVerticalScrollbar = document.getElementById("menu_container").scrollHeight > window.innerHeight;

		$("main").toggle();
		$("footer").toggle();
		$(".warnings").toggle();
		$(".fullnav").toggle();
	});

	$("html").on("click", ".header__button__search", function (e) {
		$(".header--searchcontainer").toggleClass("is-active");
		$(".frontpage_template .header--searchcontainer").css("position", "absolute");
		$(this).toggleClass("is-active");

		$(".header__search__input").focus();
		// .keyup(function (e) {
		// 	const key = e.keyCode || e.which;
		// 	const searchstring = $(this).val();
		// 	if (key === 13 && searchstring.length > 0) {
		// 		parent.location = `/search/${searchstring}`;
		// 	}
		// });
	});

	$("html").on("keyup", ".header__search__input", (e) => {
		const newSearchstring = $(e.target).val();
		const inputs = document.getElementsByClassName("header__search__input");
		// const searchstring = Array.from(inputs).find((input) => input.value.trim() !== "").value;
		for (const input of inputs) {
			input.value = newSearchstring;
		}
		if (e.key === "Enter" && newSearchstring.length > 0) {
			parent.location = `/search/${newSearchstring}`;
		}
	});

	$("html").on("click", ".header__button__dosearch", (e) => {
		// const searchstring = $(".header__search__input").val();
		const inputs = document.getElementsByClassName("header__search__input");
		const searchstring = Array.from(inputs).find((input) => input.value.trim() !== "").value;
		if (searchstring.length > 0) {
			parent.location = `/search/${searchstring}`;
		}
	});

	$("body").on("click", ".header__search__input", (e) => {
		e.stopPropagation();
	});

	$("html").on("click", ".header__button__link", function (e) {
		if ($(this).hasClass("open-new-window")) {
			window.open($(this).attr("data-link"), "_blank");
		} else {
			parent.location = $(this).attr("data-link");
		}
	});

	const langSelector = document.querySelector(".header__button__translate");
	if (langSelector !== undefined) {
		document.querySelector(".header__button__translate")?.addEventListener("click", (e) => {
			$(".google-translate-panel").toggleClass("d-none");
		});
	}

	$(".header__search__closebutton").on("click", () => {
		if (!$("this").hasClass("header__button__dosearch")) {
			$(".header__button__text.is-active").removeClass("is-active");
			$(".header--searchcontainer").hide();
		}
		$(".header__button__search").toggleClass("is-active");
	});

	$(".skip").on("click", (event) => {
		if (event.target.tagName === 'A') {
			const menuButton = document.getElementById('menu-button');
			menuButton.focus();
			if (menuButton.getAttribute('aria-expanded') === 'false') {
				toggleMenu();
			}
		}
	});

	$(window).on("resize", (e) => {
		const destination = window.screen.availWidth <= 768 ? $(".fullnav__main") : $(".header__button__search");
		$(".language__selector").insertBefore(destination);
		$(".userlogin__selector").insertBefore(destination);
		$(".header__custom-container").insertBefore(destination);
	});

	const doNotUseKari = window.serverdata.configMeta.aim?.doNotUseKari ?? false;
	if (!doNotUseKari) {
		kari();
	}

	const destination = window.screen.availWidth <= 768 ? $(".fullnav__main") : $(".header__button__search");
	$(".language__selector").insertBefore(destination);
	$(".userlogin__selector").insertBefore(destination);
	$(".header__custom-container").insertBefore(destination);
}

export const customLinks = (customLinks, lang = false) => {
	let result = "";
	let itemList = "";

	const langSelector =
		window.serverdata.configMeta.aim.languageSelector?.showGoogleLanguages === true
			? `
        <span class="header__translate__container justify-content-sm-center">
            <button class="header__button__translate notranslate" data-js="gTranslate">
                <span class="header__button__text">Language</span>
                <span class="material-icons-outlined notranslate header__icon" aria-hidden="true">
                    expand_more
                </span>
            </button>
            ${lang
				? `<div class="google-translate-panel d-none" role="application" aria-label="google translate">
                      <div id="google_translate_element"></div>
                    </div>`
				: ""
			}
        </span>`
			: "";

	if (customLinks !== undefined && customLinks.length > 0) {
		for (const item of customLinks) {
			itemList += `
                <button class="header__button__link ${item.cssClass}" data-link="${item.link}" type="button">
                  <div>
                    <span class="material-icons-outlined notranslate header__icon">${item.icon}</span>
                    <span class="header__button__text">${item.title}</span>
                  </div>
                </button>`;
		}
	}
	result = `
					<div class="header__custom-container">
							${langSelector}
							${itemList}
					</div>`;

	return result;
};

export const toggleMenu = () => {
	const menuButton = $('menu-button');
	menuButton.toggleClass("is-active");
	const isExpanded = menuButton.attr('aria-expanded') === 'true';
	menuButton.attr('aria-expanded', !isExpanded);
	$(".header").toggleClass("is-active");

	const menu = document.getElementById('menu_container');
	const originalDisplay = menu.style.display;
	const frontpageShield = document.querySelector('.frontpage_template .header__shield');
	const menuVisible = menu && window.getComputedStyle(menu).display === 'block';

	// Choose the appropriate logo filepath
	let chosenLogo = null;
	if (logoFrontpageMenu?.filepath && !menuVisible) {
		chosenLogo = logoFrontpageMenu.filepath;
	} else if (logoFrontpage?.filepath && menuVisible) {
		chosenLogo = logoFrontpage.filepath;
	}

	// Apply the logo if everything’s in place
	if (chosenLogo && frontpageShield) {
		frontpageShield.src = chosenLogo;
	}

	menu.style.display = "block";
	// const width = menu.offsetWidth;
	menu.style.display = originalDisplay;

	// const mainHasVerticalScrollbar = document.documentElement.scrollHeight > window.innerHeight;
	// const menuHasVerticalScrollbar = document.getElementById("menu_container").scrollHeight > window.innerHeight;

	$("main").toggle();
	$("footer").toggle();
	$(".warnings").toggle();
	$(".fullnav").toggle();
};
